import React, { useEffect, useRef, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { Drawer, Field, inputCls } from "../team/shared";

export function ImportLeads({ onClose, onDone }) {
  const [members, setMembers] = useState([]);
  const [assign, setAssign] = useState("auto");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const fileRef = useRef();
  useEffect(() => { client.get("/partners").then(({ data }) => setMembers(data.filter((m) => m.active))).catch(() => {}); }, []);
  const upload = async () => {
    const file = fileRef.current?.files?.[0];
    if (!file) { toast.error("CSV file choose karein"); return; }
    const fd = new FormData();
    fd.append("file", file); fd.append("assign", assign);
    setBusy(true);
    try { const { data } = await client.post("/leads/import", fd); setRes(data); toast.success(`${data.created} leads imported`); onDone(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Drawer title="Upload Leads (CSV)" onClose={onClose} testid="import-leads-drawer">
      <div className="space-y-4">
        <p className="text-xs text-slate-400">CSV me columns: Name, Email, Phone, Capital (naam thode alag ho to bhi chalega). Duplicate phone/email skip ho jayenge.</p>
        <Field label="CSV file"><input data-testid="import-file" ref={fileRef} type="file" accept=".csv,text/csv" className="text-xs text-slate-300 pt-1" /></Field>
        <Field label="Assign to">
          <select data-testid="import-assign" value={assign} onChange={(e) => setAssign(e.target.value)} className={inputCls}>
            <option value="auto">Auto — partners me baari-baari se</option>
            <option value="none">Kisi ko nahi (unassigned)</option>
            {members.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </Field>
        <button data-testid="import-submit" disabled={busy} onClick={upload} className="btn-gold w-full py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60"><Upload size={14} />{busy ? "Uploading…" : "Upload Leads"}</button>
        {res && (
          <div data-testid="import-result" className="text-xs border border-gold/40 bg-gold/5 p-3 space-y-1 text-slate-300">
            <div>{res.created} created · {res.duplicates} duplicates · {res.skipped} skipped</div>
            {Object.entries(res.assigned).map(([n, c]) => <div key={n}>{n}: {c} leads (Telegram alert sent if connected)</div>)}
          </div>
        )}
      </div>
    </Drawer>
  );
}
